import { FC, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Select, MenuItem, FormControl } from '@material-ui/core';
import { useStylesSecond } from './styles';
import { BootstrapInput } from './styles';
import { ImportTable } from './UserImport';
import { DepartmentLogs } from './DepartmentImport';
import { GroupLogs } from './GroupImport';
import { Search } from 'components/Search';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';

export const SelectShowRequest: FC = observer(() => {
  const classes = useStylesSecond();
  const [selectedPage, setSelectedPage] = useState<string>('Users');
  const {
    importTableStore: { setFilter, getGroupLogs, getDepartmentLogs, getImportLdapLogs, importView },
    notificationStore: { openNotification },
  } = useStore();
  useEffect(() => {
    document.title = `EasyIdentity: Reports: Admin ${selectedPage}`;
  }, [selectedPage]);

  const getImportReq = useQuery('getImport', () => getImportLdapLogs(), {
    onError: (error: Error) => openNotification('error', error.message),
  });
  const getGroupReq = useQuery('getGroup', () => getGroupLogs(), {
    onError: (error: Error) => openNotification('error', error.message),
  });
  const getDepartmentReq = useQuery('getDepartment', () => getDepartmentLogs(), {
    onError: (error: Error) => openNotification('error', error.message),
  });
  useAppPreloader(getGroupReq.isFetching);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedPage(event.target.value as string);
  };
  console.log(importView);
  return (
    <>
      <Grid container alignItems='center' className={classes.box}>
        <Grid item>
          <FormControl>
            <Select
              className={classes.select}
              MenuProps={{
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                getContentAnchorEl: null,
              }}
              id='select'
              value={selectedPage}
              onChange={handleChange}
              input={<BootstrapInput />}
            >
              {getImportReq.data && getImportReq.data.length > 0 ? <MenuItem value='Users'>Users</MenuItem> : null}
              {getGroupReq.data && getGroupReq.data.length > 0 ? <MenuItem value='Group'>Group</MenuItem> : null}
              {getDepartmentReq.data && getDepartmentReq.data.length > 0 ? (
                <MenuItem value='Department'>Department</MenuItem>
              ) : null}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <div>
            <Search handelSearch={setFilter} />
          </div>
        </Grid>
      </Grid>
      <Grid item xl className={classes.tabsPanel}>
        <Paper className={classes.tabsPaper}>
          <div className={classes.tabBox}>
            {selectedPage === 'Users' && <ImportTable />}
            {selectedPage === 'Group' && <GroupLogs />}
            {selectedPage === 'Department' && <DepartmentLogs />}
          </div>
        </Paper>
      </Grid>
    </>
  );
});
